import { EnvironmentConfig } from 'types';

export const THIRD_PARTY_AUTH_SERVICE: EnvironmentConfig = {
  dev: 'https://third-party-authentication-service-dev1.headliner.app',
  prod: 'https://third-party-authentication-service.headliner.app',
};

export const AUTHENTICATION_SERVICE: EnvironmentConfig = {
  dev: 'https://authentication-service-dev1.sparemin.com',
  prod: 'https://authentication-service.sparemin.com',
};

export const USER_SERVICE: EnvironmentConfig = {
  dev: 'https://user-service-dev1.sparemin.com',
  prod: 'https://user-service.sparemin.com',
};
